import axios from 'axios';

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '/api';

const normalizedApiBase = API_BASE_URL.replace(/\/$/, '');
export const isInteraEnv = normalizedApiBase === 'https://app.intera-ai.io/api';

// Create axios instance with base configuration
export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});
